import React, {useState} from 'react';
import ModalWindow from '../common/ModalWindow';
import HelpContent from './components/HelpContent';
import StatisticContent from './components/StatisticContent';
import Statistic from "../../images/statistic.svg";
import Help from "../../images/help.svg";
import {TBrand} from "../../types";

import "./Header.component.scss";

/* ----- Types ----- */
type Props = {
  currentGame: TBrand | undefined
};

/* ----- Main Component ----- */
const Header = (props: Props) => {

  const [helpModalIsOpen, setHelpModalIsOpen] = useState<boolean>(false);
  const [statisticsModalIsOpen, setStatisticsModalIsOpen] = useState<boolean>(false);

  const {currentGame} = props;

  return (
    <div className="header">
      <div className='header__title'>
        <div>
          <img
            src={Help}
            alt=""
            onClick={() => setHelpModalIsOpen(true)}
          />
        </div>
        <div className='header__text'>
          <span>BRAND</span>LE
        </div>
        <div>
          <img
            src={Statistic}
            alt=""
            onClick={() => setStatisticsModalIsOpen(true)}
          />
        </div>
      </div>

      <div className="header__horizontal-line "> </div>

      <div className='header__subtitle'>
        Guess the brand based on the logo!
        <br/>
        {`Industry: ${currentGame?.category.join(", ")}`}
        {/*{currentGame?.marketCap && (*/}
          {/*<span style={{marginLeft: '40px'}}>*/}
            {/*{`GMV: $${currentGame?.marketCap / 1000000}M`}*/}
          {/*</span>*/}
        {/*)}*/}
      </div>

      <ModalWindow
        isOpen={helpModalIsOpen}
        onRequestClose={() => setHelpModalIsOpen(false)}
        title='HOW TO PLAY'
      >
        <HelpContent/>
      </ModalWindow>

      <ModalWindow
        isOpen={statisticsModalIsOpen}
        onRequestClose={() => setStatisticsModalIsOpen(false)}
        title='STATISTIC'
      >
        <StatisticContent/>
      </ModalWindow>
    </div>
  );
};

export default Header;
